import styled from 'styled-components';
import { LayoutConst } from 'core';

export const RoomLaunchContainer = styled.div<{ $isLaunched?: boolean }>`
  width: 100%;
  max-width: 1152px;
  height: auto;
  margin: 0 auto;
  overflow: visible;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 888px;
    height: auto;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    width: 100%;
    height: auto;
    min-height: auto;
    margin: 0 16px;
    max-width: calc(100% - 32px);
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    max-width: 100%;
    margin: auto;
    padding: 0 10px;
  }
  
`;

export const TopSection = styled.div`
  height: 140px;
  background-color: #000000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 40px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    height: 100px;
    padding-top: 20px;
  }
`;

export const Title = styled.h2`
  color: white;
  font-size: 42px;
  line-height: 48px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  margin: 0;
  text-align: center;

  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 32px;
    line-height: 36px;
  }
`;

export const ControlBar = styled.div`
  height: 62px;
  background-color: #2a2a2a;
  display: flex;
  align-items: center;
  padding: 0 24px;
  gap: 24px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    height: auto;
    gap: 16px;
  }
`;

export const PlatformSection = styled.div`
  display: flex;
  gap: 20px;
  flex: 1;

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-left: 0;
    padding: 16px 0;
  }
`;

export const PlatformItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 8px;
  min-width: 80px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    min-width: 60px;
    gap: 0px;
  }
`;

export const PlatformLabel = styled.span<{ $isRequired?: boolean }>`
  color: white;
  font-size: 13px;
  font-weight: 500;
  position: relative;

  &.required::after,
  ${props => props.$isRequired && `
    &::after {
      content: '*';
      color: #ff4444;
      margin-left: 2px;
      font-size: 12px;
    }
  `}
`;

export const AddButton = styled.button`
  color: white;
  font-size: 13px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: all 0.2s ease;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: ${LayoutConst.screen.md}px) {
    min-width: 80px;
    font-size: 11px;
    text-align: start;
  }
`;

export const SaveButton = styled.button<{ disabled?: boolean }>`
  background-color: ${props => props.disabled ? '#666' : 'white'};
  color: ${props => props.disabled ? '#999' : 'black'};
  border: none;
  border-radius: 3px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #f0f0f0;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    padding: 8px 16px;
    font-size: 12px;
  }
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const SuccessIcon = styled.div`
  width: 48px;
  height: 48px;
  background-color: #4a9eff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
`;

export const LaunchedTopSection = styled.div`
  height: 176px;
  background-color: #000000;
  display: flex;
  align-items: center;
  padding: 0 40px;
  position: relative;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 126px;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    height: auto;
    min-height: 120px;
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

export const LaunchedContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const QuestionIconContainer = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -30px;
  cursor: pointer;
`;

export const PlatformProgressContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const PlatformProgressWrapper = styled.div`
  flex: 1;
  height: 4px;
  background-color: #333;
  border-radius: 2px;
  overflow: hidden;
`;

export const PlatformProgressBar = styled.div<{ progress: number }>`
  height: 100%;
  background-color: white;
  width: ${props => props.progress}%;
  transition: width 0.3s ease;
`;

export const CancelButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  
  &:hover {
    opacity: 0.7;
  }
`;

export const CancelIcon = styled.svg`
  width: 16px;
  height: 16px;
`;

export const LaunchedTitle = styled.a`
  color: white !important;
  font-size: 42px;
  line-height: 48px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  margin: 0 0 8px 0;
  text-align: left;
  text-decoration: underline !important;
  text-underline-offset: 9px;
  cursor: pointer;

  &:visited {
    color: white !important;
  }

  &:hover {
    color: white !important;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 32px;
    line-height: 36px;
  }
`;

export const PlatformsList = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;
`;

export const PlatformName = styled.div`
  color: #909090;
  font-size: 13px;
  line-height: 16px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
`;

export const EditButton = styled.button`
  position: absolute;
  background: none;
  top: 16px;
  right: 16px;
  color: black;
  border: none;
  padding: 16px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;

  ${LaunchedTopSection}:hover & {
    opacity: 1;
    pointer-events: auto;
  }

  &:hover {
    svg {
        rect{
            fill: #f0f0f0;
        }
        path{
            stroke: #f0f0f0;
        }
    }
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    top: 12px;
    right: 12px;
    padding: 12px;
  }
`;

import styled from 'styled-components';
import { LayoutConst } from 'core';

export const RoomLaunchContainer = styled.div<{ $isLaunched?: boolean }>`
  width: 100%;
  max-width: 1152px;
  height: auto;
  margin: 0 auto;
  overflow: visible;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    width: 888px;
    height: auto;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    width: 100%;
    height: auto;
    min-height: auto;
    margin: 0 16px;
    max-width: calc(100% - 32px);
  }

  @media (max-width: ${LayoutConst.screen.s - 1}px) {
    max-width: 100%;
    margin: auto;
    padding: 0 10px;
  }
  
`;

export const TopSection = styled.div`
  height: 140px;
  background-color: #000000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 40px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    height: 100px;
    padding-top: 20px;
  }
`;

export const Title = styled.h2`
  color: white;
  font-size: 42px;
  line-height: 48px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  margin: 0;
  text-align: center;

  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 32px;
    line-height: 36px;
  }
`;

export const ControlBar = styled.div`
  height: 62px;
  background-color: #2a2a2a;
  display: flex;
  align-items: center;
  padding: 0 24px;
  gap: 24px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    height: auto;
    gap: 16px;
  }
`;

export const PlatformSection = styled.div`
  display: flex;
  gap: 20px;
  flex: 1;

  @media (max-width: ${LayoutConst.screen.md}px) {
    margin-left: 0;
    padding: 16px 0;
  }
`;

export const PlatformItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 8px;
  min-width: 80px;

  @media (max-width: ${LayoutConst.screen.md}px) {
    min-width: 60px;
    gap: 0px;
  }
`;

export const PlatformLabel = styled.span<{ $isRequired?: boolean }>`
  color: white;
  font-size: 13px;
  font-weight: 500;
  position: relative;

  &.required::after,
  ${props => props.$isRequired && `
    &::after {
      content: '*';
      color: #ff4444;
      margin-left: 2px;
      font-size: 12px;
    }
  `}
`;

export const AddButton = styled.button`
  color: white;
  font-size: 13px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: all 0.2s ease;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media (max-width: ${LayoutConst.screen.md}px) {
    min-width: 80px;
    font-size: 11px;
    text-align: start;
  }
`;

export const SaveButton = styled.button<{ disabled?: boolean }>`
  background-color: ${props => props.disabled ? '#666' : 'white'};
  color: ${props => props.disabled ? '#999' : 'black'};
  border: none;
  border-radius: 3px;
  padding: 10px 20px;
  font-size: 14px;
  font-weight: 600;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #f0f0f0;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    padding: 8px 16px;
    font-size: 12px;
  }
`;

export const HiddenInput = styled.input`
  display: none;
`;

export const SuccessIcon = styled.div`
  width: 48px;
  height: 48px;
  background-color: #4a9eff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
`;

export const LaunchedTopSection = styled.div`
  height: 176px;
  background-color: #000000;
  display: flex;
  align-items: center;
  padding: 0 40px;
  position: relative;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    height: 126px;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    height: auto;
    min-height: 120px;
    padding: 20px;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

export const LaunchedContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const QuestionIconContainer = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: -30px;
  cursor: pointer;
`;

export const PlatformProgressContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const PlatformProgressWrapper = styled.div`
  flex: 1;
  height: 4px;
  background-color: #333;
  border-radius: 2px;
  overflow: hidden;
`;

export const PlatformProgressBar = styled.div<{ progress: number }>`
  height: 100%;
  background-color: white;
  width: ${props => props.progress}%;
  transition: width 0.3s ease;
`;

export const CancelButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  
  &:hover {
    opacity: 0.7;
  }
`;

export const CancelIcon = styled.svg`
  width: 16px;
  height: 16px;
`;

export const LaunchedTitle = styled.a`
  color: white !important;
  font-size: 42px;
  line-height: 48px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
  margin: 0 0 8px 0;
  text-align: left;
  text-decoration: underline !important;
  text-underline-offset: 9px;
  cursor: pointer;

  &:visited {
    color: white !important;
  }

  &:hover {
    color: white !important;
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    font-size: 32px;
    line-height: 36px;
  }
`;

export const PlatformsList = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 16px;
`;

export const PlatformName = styled.div`
  color: #909090;
  font-size: 13px;
  line-height: 16px;
  font-weight: 600;
  font-family: 'Inter', sans-serif;
`;

export const EditButton = styled.button`
  position: absolute;
  background: none;
  top: 16px;
  right: 16px;
  color: black;
  border: none;
  padding: 16px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;
  display: flex;
  align-items: center;
  justify-content: center;

  ${LaunchedTopSection}:hover & {
    opacity: 1;
    pointer-events: auto;
  }

  &:hover {
    svg {
        rect{
            fill: #f0f0f0;
        }
        path{
            stroke: #f0f0f0;
        }
    }
  }

  @media (max-width: ${LayoutConst.screen.md}px) {
    top: 12px;
    right: 12px;
    padding: 12px;
  }
`;

